<template>
    <CalendarMonth
        class="date-picker-month"
        :id="uniqueId"
        :range="selectedRange"
        :navigation="navigation"
        :year="monthData.year"
        :days="monthData.days"
        :weeks="monthData.weeks"
        :month="monthData.month"
        @selectionChanged="handleSelection"
        @navigation="handleNavigation"
    />
</template>

<script>
import CalendarMonth from 'components/dateRange/CalendarMonth.vue';
import dateServices from 'components/dateRange/DateServices';
import moment from 'moment';

export default {
    name: 'DatePickerMonth',
    components: { CalendarMonth },
    props: {
        uniqueId: String,
        selected: {
            type: Date,
            default: null
        },
        includeToday: {
            type: Boolean,
            default: true
        },
        allowFutureDates: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            monthData: this.getMonthDataFromDate(dateServices.getCurrentTimeUTC())
        };
    },
    computed: {
        selectedRange() {
            return this.getRangeFromDate(this.selected);
        },
        navigation() {
            if (this.allowFutureDates) return 'all';
            const current = moment(dateServices.getCurrentTimeUTC()).startOf('month');
            // if month is in the future, only navigate back
            return moment([this.monthData.year, this.monthData.month])
                .diff(current, 'months') >= 0 ? 'previous' : 'all';
        }
    },
    methods: {
        resetMonth() {
            const date = this.selected || dateServices.getCurrentTimeUTC();
            this.monthData = this.getMonthDataFromDate(date);
        },
        handleNavigation(direction) {
            const date = new Date(this.monthData.year, this.monthData.month);
            const newDate = direction === 'next'
                ? moment(date).add(1, 'month')
                : moment(date).subtract(1, 'month');
            // show next/prev month on popup
            this.monthData = this.getMonthDataFromDate(newDate.toDate());
        },
        handleSelection(day) {
            if (day.isFuture) return;
            this.$emit('update:selected', day.date);
        },
        getMonthDataFromDate(date) {
            const month = date.getMonth();
            const year = date.getFullYear();
            return dateServices.createMonth(month, year, this.includeToday, !this.allowFutureDates);
        },
        getRangeFromDate(date) {
            const d = date || null;
            return {
                fromStart: d,
                fromEnd: d,
                toStart: d,
                toEnd: d
            };
        }
    },
    mounted() {
        this.resetMonth();
    },
    watch: {
        selected() {
            this.resetMonth();
        },
        allowFutureDates() {
            // refresh month data
            this.monthData = this.getMonthDataFromDate(new Date(this.monthData.year, this.monthData.month));
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.date-picker-month {
    // adjust the 'next' button position of the CalendarMonth component
    ::v-deep .next {
        margin-top: 17px;
    }
}
</style>
